import { useState, useEffect } from "react";
import Loader from "react-spinners/ScaleLoader";
import "../../App.css";
import { Services } from "../../Services";
import { ToastError } from "../../Components/utils/ToastMessage";
import dashboardclasses from "../dashboard.module.css";
import Modal from "./sendNotification/Modal";
import User from "../../Assets/user.jpg";
import NotificationClasses from "./notifications.module.css";
import Layout from "../../Components/Layout/layout";
import moment from "moment";
function Warehouse() {
    const [loading, setLoading] = useState(true);
    const [allNotifications, setallNotifications] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [Navactive, setNavactive] = useState("user");
    const fetchNotifications = async () => {
        try {
            setLoading(true);
            const response = await Services.getNotifications(
                "get",
                null,
                token,
                Navactive
            );
            console.log(response);
            if (response.Status == 1) {
                setallNotifications(response?.Notifications);
            } else {
                ToastError("Failed to fetch notifications");
            }
        } catch (error) {
            ToastError("An error occurred while fetching notifications");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchNotifications();
    }, [Navactive]);

    const navactivehandler = (type) => {
        setNavactive(type);
    };
    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                setIsModalOpen={setIsModalOpen}
                fetchNotifications={fetchNotifications}
            />
            <Layout Active={"Notifications"}>
                <div className={dashboardclasses.CategoryWrapper}>
                    <div className={dashboardclasses["category-form-two"]}>
                        <h3>Notifications</h3>
                        <button onClick={() => setIsModalOpen(true)}>
                            Send Notification
                        </button>
                    </div>
                    <div className={dashboardclasses["orders-navbar"]}>
                        <button
                            className={
                                Navactive === "user" &&
                                dashboardclasses["order-active"]
                            }
                            onClick={() => navactivehandler("user")}>
                            User
                        </button>
                        <button
                            className={
                                Navactive === "driver" &&
                                dashboardclasses["order-active"]
                            }
                            onClick={() => navactivehandler("driver")}>
                            Driver
                        </button>
                    </div>
                    <div className={NotificationClasses["Container"]}>
                        {loading ? (
                            <Loader />
                        ) : allNotifications.length ? (
                            allNotifications.map((item) => (
                                <div
                                    className={
                                        NotificationClasses["Notification"]
                                    }>
                                    <img src={User} alt="" />
                                    <div
                                        className={
                                            NotificationClasses["content"]
                                        }>
                                        <h5>{item?.title}</h5>
                                        <p>{item?.body}</p>
                                        <p>
                                            {moment(item?.created_at).fromNow()}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className={NotificationClasses["no-new"]}>
                                No New Notifications
                            </p>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
